import { connect } from "react-redux";
import { buttonElementModel } from "../../../models/common/buttonElement.model";
import ButtonElementComponent from "../../common/ButtonElementComponent";
import { bindActionCreators } from "redux";
import { transactionPaymentActions } from "../../../store/actions/transactions/transactionPayment.actions";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import validationHelper from "../../../utils/helpers/validation.helper";
import { useEffect, useState } from "react";
import LoaderComponent from "../../LoaderComponent";
import { CreditCardsListComponent } from "./paymentDetailsStep/CreditCardsListComponent";
import alertService from "../../../services/alert/alert.service";
import queryParamsHelper from "../../../utils/helpers/queryParams.helper";

export const PaymentDetailsStepComponent = ({ transactionPaymentActions, chargePoint, handleBack, handleNext }) => {
  const navigate = useNavigate();
  const { companyId, chargePointId } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  
  const clientId = queryParamsHelper.get(searchParams, 'clientId');
  
  const [creditCardsList, setCreditCardsList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedCreditCardId, setSelectedCreditCardId] = useState("-1");

  useEffect(() => {
    if (clientId) {
      getPaymentTokenList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clientId]);

  const getPaymentTokenList = async () => {
    setIsLoading(true);
    const response = await transactionPaymentActions.getCreditCardsDetails(companyId, clientId);
    if (validationHelper.validateHttpResponse(response) && response.payload) {
      setCreditCardsList(response.payload);
      if (response.payload.length > 0) setSelectedCreditCardId(response.payload[0].id);
    }
    setIsLoading(false);
  };

  const handleSubmitAddNewCreditCard = async () => {
    setIsLoading(true);
    const response = await transactionPaymentActions.getPaymentPage(companyId, clientId, chargePointId);
    setIsLoading(false);

    if (!validationHelper.validateHttpResponse(response) || !response.payload) {
      alertService.error("התקבלה שגיאה בעת מעבר לעמוד הכנסת פרטי אשראי", buildContactMessageForError());
      return;
    }
    window.location.href = response.payload;
  };

  const buildContactMessageForError = () => {
    const { contactPhone, notificationEmail } = chargePoint.company;
    let message = "לפרטים נוספים, ניתן ליצור קשר עם התמיכה באחת מהדרכים:";
    message += contactPhone ? `\n במספר: ${contactPhone}` : "";
    message += notificationEmail ? `\n באימייל: ${notificationEmail}` : "";
    return contactPhone || notificationEmail ? message : "";
  };

  const handleSubmitChargeExsiting = async () => {
    // Validate selectedCreditCardId is valid
    if (!selectedCreditCardId || selectedCreditCardId === "-1") {
      alertService.error("שגיאה", "אנא בחר אמצעי תשלום");
      return;
    }

    // Set both paymentTokenId and step in a single atomic operation to avoid race condition
    // This ensures both parameters are set together, preventing the step update from overwriting paymentTokenId
    const newParams = queryParamsHelper.setMultiple(searchParams, {
      paymentTokenId: selectedCreditCardId,
      step: '4' // startChargingTransaction step
    });
    setSearchParams(newParams, { replace: true });
    // Don't call handleNext() separately - we've already set the step above
  };

  const handleDeleteCreditCard = async (creditCard) => {
    const userChoice = await alertService.confirm("האם אתה בטוח שברצונך להסיר אמעצי תשלום זה?", "שים לב! פעולה זו בלתי הפיכה", "כן הסר", "לא");
    if (!userChoice) return;

    setIsLoading(true);
    const response = await transactionPaymentActions.deleteClientPaymentToken(creditCard.id);
    setIsLoading(false);

    if (!validationHelper.validateHttpResponse(response)) {
      alertService.error("שגיאה במחיקת אמצעי תשלום", "אנא נסה שנית מאוחר יותר");
      return;
    }
    getPaymentTokenList();
    alertService.success("אמצעי תשלום נמחק בהצלחה");
  };

  const handleSelectCreditCard = (event) => {
    const { name, value } = event.target;
    setSelectedCreditCardId(value);
  };

  const getCreditCardsListElement = () => {
    const creditCardsListProps = { creditCardsList, selectedCreditCardId };
    creditCardsListProps.functions = { handleSelectCreditCard, handleDeleteCreditCard };
    return <CreditCardsListComponent props={creditCardsListProps} />;
  };

  const getAddNewCreditCardButtonElement = () => {
    const buttonElementProps = {
      ...buttonElementModel,
      label: "מעבר לעמוד אמצעי תשלום",
      onClick: handleSubmitAddNewCreditCard,
    };

    return <ButtonElementComponent buttonElementProps={buttonElementProps} />;
  };

  const getChargeSelectedCreditCardButtonElement = () => {
    const buttonElementProps = {
      ...buttonElementModel,
      label: "המשך לתחילת טעינה",
      onClick: handleSubmitChargeExsiting,
    };

    return <ButtonElementComponent buttonElementProps={buttonElementProps} />;
  };

  if (isLoading) return <LoaderComponent />;

  return (
    <div className="flexColumn gap10">
      {getCreditCardsListElement()}

      {selectedCreditCardId === "-1" && (
        <div className="flexColumn gap10">
          <span>לחץ המשך למעבר לעמוד הכנסת פרטי אשראי</span>
          <span>שם לב! לאחר הכנסת פרטי האשראי, תנותב חזרה לעמוד זה על מנת לבחור את אמצעי התשלום איתו תרצה לשלם בעבור הטעינה</span>
        </div>
      )}
      {selectedCreditCardId === "-1" && getAddNewCreditCardButtonElement()}

      {selectedCreditCardId !== "-1" && getChargeSelectedCreditCardButtonElement()}
    </div>
  );
};

const mapStateToProps = (state) => ({
  transactionClientReducer: state.transactionClientReducer,
});

const mapDispatchToProps = (dispatch) => {
  return {
    transactionPaymentActions: bindActionCreators(transactionPaymentActions, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PaymentDetailsStepComponent);
